// <MobileViewModeToggle> — T-287, mobile-three-buttons-implementation-plan.md §4.
//
// Top-right header icon button to toggle between simple and advanced mobile views.
// Click flips the useMobileViewMode persisted value and re-renders.

import { LayoutGrid } from 'lucide-react';
import { useMobileViewMode } from '../../components/useMobileViewMode';

export function MobileViewModeToggle() {
  const mobile = useMobileViewMode();

  const isAdvanced = mobile.viewMode === 'advanced';
  const nextViewMode = isAdvanced ? 'simple' : 'advanced';
  const ariaLabel = isAdvanced ? 'Switch to simple view' : 'Switch to advanced view';

  return (
    <button
      type="button"
      onClick={() => mobile.setViewMode(nextViewMode)}
      aria-label={ariaLabel}
      data-testid="mobile-view-mode-toggle-icon"
      className="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-500 flex items-center justify-center transition-colors"
    >
      <LayoutGrid size={20} />
    </button>
  );
}
